<template>
    <svg class="minajin-logo-small" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="40px"
        height="40px" viewBox="0 0 58 58" style="enable-background:new 0 0 58 58;" xml:space="preserve">
        <path fill="#f38900" d="M49.8,5H6.8c-1.6,0-3,1.3-3,3V51c0,1.6,1.4,3,3,3h14.8l-9.2-9.2V13.5h6.1l9.6,11.7l9.6-11.7h6.1l9,9V8C52.8,6.3,51.5,5,49.8,5z"/>
        <path fill="#e54904" d="M43.8,13.5v31.3h-6.1V23.1L32.1,30l-3.9,4.8l-4-4.8l-5.7-6.9v21.8h-6.1l9.2,9.2h28.2c1.7,0,3-1.4,3-3V22.5L43.8,13.5z"/>
    </svg>
</template>
